import React from 'react';
import usePreviousComparison from '../../hooks/usePreviousComparison';
import KpiCard from './KpiCard';
import MetricSummary from './MetricSummary';
import InterveneMetricSummary from './InterveneMetricSummary';
import LineBarChart from './LineBarChart';
import PieChartSection from './PieChartSection';
import ReportTableSection from '../viewer/ReportTableSection';

export default function AnalyticsChartRenderer({
  result,
  visualization,
  sx,
  chartLabels = {},
  compact = false,
  height,
  querySpec,
  orgId,
  displayMode = 'count',
}) {
  const comparison = usePreviousComparison(
    result?.kind === 'number' && !result?.metrics?.length ? querySpec : null,
    orgId,
    result?.value,
  );
  if (!result) return null;

  const {
    xAxisLabel = '',
    yAxisLabel = '',
    seriesLabel = '',
    chartSubtitle = '',
    valueFormat = 'number',
  } = chartLabels;

  if (visualization === 'number' || (!visualization && result.kind === 'number')) {
    if (Array.isArray(result.metrics) && result.metrics.length) {
      const isInterveneOverview = result.metrics.some((item) => item.id === 'avg_agent_response');
      if (isInterveneOverview) {
        return (
          <InterveneMetricSummary
            metrics={result.metrics}
            focusedUserDisplayName={chartLabels.focusedUserDisplayName || ''}
            compact={compact}
          />
        );
      }
      return <MetricSummary metrics={result.metrics} />;
    }
    return (
      <KpiCard
        value={result.display || result.value}
        label={yAxisLabel || seriesLabel || result.label}
        comparison={comparison}
        compact={compact}
      />
    );
  }

  if (visualization === 'table' || (!visualization && result.kind === 'table')) {
    return (
      <ReportTableSection
        result={result}
        sx={sx}
        compact={compact}
        categoryLabel={xAxisLabel}
        measureLabel={yAxisLabel || seriesLabel}
        columnLabels={chartLabels.columnLabels || {}}
        valueFormat={valueFormat}
        querySpec={querySpec}
        orgId={orgId}
      />
    );
  }

  if (visualization === 'pie') {
    return (
      <PieChartSection
        result={result}
        colors={sx?.chartColors}
        valueFormat={valueFormat}
        compact={compact}
        height={height || (compact ? 220 : 300)}
      />
    );
  }

  const chartKind = visualization === 'line' || visualization === 'bar'
    ? visualization
    : result.kind === 'bar' ? 'bar' : 'line';
  return (
    <LineBarChart
      result={result}
      kind={chartKind}
      colors={sx?.chartColors}
      xAxisLabel={xAxisLabel}
      yAxisLabel={yAxisLabel}
      valueFormat={valueFormat}
      compact={compact}
      height={height || (compact ? 220 : 300)}
      displayMode={displayMode}
      isRecords={querySpec?.dataset === 'records' || result?.dataset === 'records'}
    />
  );
}
